// extracted by mini-css-extract-plugin
export default {"container":"LayoutNew_container__UrPIm","sub_container":"LayoutNew_sub_container__HR0wH"};